<template>
  <!-- replace the below <div class="d-flex flex-column bg-light"> with <body class="d-flex flex-column bg-light"> -->
  <div class="d-flex flex-column bg-white">
    <Header />
    <div class="sticky-top">
      <div style="min-height: 0.4rem" class="bg-secondary">
        <div id="pageProgress" class="progress indeterminate hidden">
          <div class="progress-bar bg-secondary"></div>
        </div>
      </div>
      <nav
        class="
          navbar navbar-expand-lg navbar-dark
          bg-primary
          elevate
          flex-shrink-0
        "
      >
        <a class="navbar-brand text-alt-secondary mr-5" href="/pfsearch"
          >Private Facilities Search</a
        >
      </nav>
    </div>
    <main class="flex-fill pl-3 pr-3 pb-3">
      <div class="p-2 m-3 elevate bg-white rounded">
        <div class="container">
          <!-- <div class="mb-3">
            <router-link to="/"
              ><i class="fas fa-long-arrow-alt-left mr-1"></i>
              Search</router-link
            >
          </div> -->

          <div class="card mb-2" v-if="IsProgramClosed">
            <div class="card-header pf-nested-card-header">
              This Facility Is Closed
            </div>
            <div class="card-body pt-2 pb-4 bg-danger text-white">
              <div class="d-flex flex-wrap justify-content-center mb-1 mt-2">
                <span class="pf-label-table-cell">Closed Date</span>
                <label class="pf-data-table-cell" id="site_status_label">
                  {{ FormattedDate(Program.ClosedDate) }}
                </label>
              </div>
            </div>
          </div>

          <div class="card mb-2" v-if="IsNotApprovedForNewPlacement">
            <!-- <div class="card-header pf-nested-card-header">
              This Site Is Closed
            </div> -->
            <div class="card-body bg-danger text-white">
              <div class="d-flex flex-wrap justify-content-center mb-1 mt-2">
                <span class="pf-label-table-cell h5"
                  >Not approved for new placement</span
                >
              </div>
            </div>
          </div>

          <div v-if="webShareApiSupported" class="float-right">
            <a href="#" title="share this page"
              ><i
                class="fas fa-share-alt mr-1 btn-link"
                @click="shareViaWebShare"
              ></i>
            </a>
          </div>
          <br />
          <h3
            class="text-primary text-center"
            style="font-weight: bold; font-size: 26px"
          >
            <small style="color: #84afd1; font-weight: bold" class="mr-2"
              >{{ $route.params.id }}
            </small>

            {{ Program.ProgramName }}

            <small style="color: #84afd1; font-weight: bold" class="ml-2">
              {{ YearDisplay }}
              <button
                type="button"
                class="btn btn-primary btn-sm float-right"
                data-toggle="modal"
                data-target=".bd-example-modal-sm"
                style="display: none"
              >
                <i class="fas fa-edit fa-sm" title="Change School Year"></i>
                Change School Year
              </button>
            </small>
          </h3>

          <div
            class="modal fade bd-example-modal-sm"
            tabindex="-1"
            role="dialog"
            aria-labelledby="mySmallModalLabel"
            aria-hidden="true"
          >
            <div class="modal-dialog">
              <div class="modal-content">
                <div class="modal-header" style="background-color: #f4f4f4">
                  <h5 class="modal-title" id="exampleModalLongTitle">
                    Change School Year
                  </h5>
                  <button
                    type="button"
                    class="close"
                    data-dismiss="modal"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div class="modal-body p-2">
                  <div class="form-group row justify-content-center my-3">
                    <div class="col-auto">
                      <label for="schoolYear" class="col-form-label label"
                        >Select year</label
                      >
                    </div>
                    <div class="col-4">
                      <select
                        id="inputSchoolYear"
                        class="form-control w100"
                        v-model="SelectedYear"
                      >
                        <option
                          :value="option.SchoolYear"
                          v-for="(option, index) in SchoolYearOptions"
                          :key="index"
                        >
                          {{ option.SchoolYear - 1 }} - {{ option.SchoolYear }}
                        </option>
                      </select>

                      <!-- <select
                        class="form-control w100"
                        data-val="true"
                        data-val-required="Year is required."
                        id="schoolYear"
                        name="schoolYear"
                        aria-describedby="IsAvailable-error"
                      >
                        <option>2021</option>
                        <option>2020</option>
                        <option>2019</option>
                        <option>2018</option>
                        <option>2017</option>
                      </select> -->
                    </div>
                  </div>

                  <!-- <div class="form-group">
                    <label for="exampleFormControlSelect1">Select year</label>
                    <select class="form-control" id="schoolYear">
                      <option>2021</option>
                      <option>2020</option>
                      <option>2019</option>
                      <option>2018</option>
                      <option>2017</option>
                    </select>
                  </div> -->
                </div>
                <div class="modal-footer">
                  <button
                    type="button"
                    class="btn btn-secondary"
                    data-dismiss="modal"
                  >
                    cancel
                  </button>
                  <button
                    type="button"
                    class="btn btn-primary"
                    @click="UpdateSchoolYear()"
                  >
                    ok
                  </button>
                </div>
              </div>
            </div>
          </div>

          <!-- Name/Contact Information - begin -->

          <div class="card mb-3">
            <div class="card-header pf-nested-card-header font-weight-bold">
              Name/Contact Information
            </div>
            <div class="card-body px-4 pt-3 pb-0">
              <div class="row">
                <div class="col-12">
                  <div class="font-weight-bold">
                    <!-- <a
                      v-bind:href="
                        Program.ProgramWebsiteUrl == ''
                          ? '#'
                          : Program.ProgramWebsiteUrl
                      "
                      target="_blank"
                      class="link"
                      data-toggle="tooltip"
                      data-placement="left"
                      title=""
                      data-original-title="view website"
                      >{{ Program.ProgramName }}</a
                    > -->

                    {{ Program.ProgramName }}
                  </div>
                </div>
              </div>
              <div class="row mb-1 mt-2">
                <div class="col-12">
                  <a
                    v-bind:href="
                      Program.ProgramWebsiteUrl == ''
                        ? '#'
                        : Program.ProgramWebsiteUrl
                    "
                    target="_blank"
                    class="link"
                    data-toggle="tooltip"
                    data-placement="left"
                    title=""
                    data-original-title="view website"
                    >{{ ProgramURL }}</a
                  >
                </div>
              </div>

              <div class="row mb-3">
                <div class="col-12">
                  <a class="link" v-bind:href="GoogleAddress" target="_blank">
                    {{ Program.ProgramAddress }}</a
                  >
                </div>
              </div>

              <div class="d-flex flex-wrap">
                <div class="mb-3 mr-5">
                  <div class="pf-table-row">
                    <div class="pf-label-table-cell">Phone</div>
                    <div class="pf-data-table-cell">
                      <a class="link" v-bind:href="ProgramPhone">{{
                        FormatPhoneNumber(Program.ProgramPhone)
                      }}</a>
                    </div>
                  </div>
                  <div class="pf-table-row">
                    <div class="pf-label-table-cell">Fax</div>
                    <div class="pf-data-table-cell">
                      <a class="link" v-bind:href="ProgramFax"
                        >{{ FormatPhoneNumber(Program.ProgramFax) }}
                      </a>
                    </div>
                  </div>
                </div>
                <div class="mb-3">
                  <div class="pf-table-row">
                    <div class="pf-label-table-cell">Site Code</div>
                    <div class="pf-data-table-cell">
                      {{ $route.params.id }}
                    </div>
                  </div>
                  <div class="pf-table-row">
                    <div class="pf-label-table-cell">RCDTS</div>
                    <div class="pf-data-table-cell">
                      {{ Program.ProgramRcdts }}
                    </div>
                  </div>
                </div>
              </div>

              <div class="d-flex flex-wrap">
                <div class="mr-4 pr-5 mb-3" style="width: 100%">
                  <div class="row">
                    <div class="col-12 font-weight-bold">Administrator</div>
                  </div>
                  <div class="row">
                    <div class="col-12">
                      {{ Program.ProgramAdminName }}
                      <small> {{ Program.ProgramAdminTitle }} </small>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12">
                      <a class="link" v-bind:href="ProgramAdminEmail">
                        {{ Program.ProgramAdminEmail }}
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- Name/Contact Information - end -->

          <div class="card mb-3">
            <div class="card-header pf-nested-card-header font-weight-bold">
              Program Information
            </div>
            <div class="card-body px-4 pt-3 pb-0">
              <table
                id="ProgInfoTable"
                class="pf-table"
                style="border-collapse: collapse"
              >
                <thead>
                  <tr>
                    <th>
                      <span
                        class="font-weight-bold"
                        style="padding: 0px !important"
                        >Public/Private</span
                      >
                    </th>
                    <th>
                      <span
                        class="font-weight-bold"
                        style="padding: 0px !important"
                        >Location Type</span
                      >
                    </th>
                    <th>
                      <span
                        class="font-weight-bold"
                        style="padding: 0px !important"
                        >Program Type</span
                      >
                    </th>
                    <th>
                      <span
                        class="font-weight-bold"
                        style="padding: 0px !important"
                        >Limited Approval</span
                      >
                    </th>
                    <th>
                      <span
                        class="font-weight-bold"
                        style="padding: 0px !important"
                        >Add On Type</span
                      >
                    </th>
                    <th>
                      <span
                        class="font-weight-bold"
                        style="padding: 0px !important"
                        >Gender</span
                      >
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td style="padding-top: 2px !important">
                      {{ Program.EntityTypeDescription }}
                    </td>
                    <td style="padding-top: 2px !important">
                      {{ Program.LocationTypeDescription }}
                    </td>
                    <td
                      style="
                        padding-top: 2px !important;
                        margin: 0px !important;
                      "
                    >
                      {{ Program.FacilityTypeDescription }}
                    </td>
                    <td style="padding-top: 2px !important">
                      <!-- Not Limited -->
                      {{ LimitedApproval }}
                    </td>
                    <td style="padding-top: 2px !important">
                      {{ Program.AddOnTypeDescription }}
                    </td>
                    <td style="padding-top: 2px !important">
                      {{ Program.GenderType }}
                    </td>
                  </tr>
                  <tr>
                    <td
                      style="padding-top: 2px !important"
                      class="pf-no-border p-3"
                      colspan="6"
                    >
                      <div class="flex-grow-1 pf-ghost-div px-4 pb-2 pt-2 m-3">
                        <span class="font-weight-bold"
                          >Disabilities Served</span
                        >
                        <table
                          class="pf-table small"
                          style="empty-cells: hide !important"
                        >
                          <thead>
                            <tr>
                              <th>
                                <span
                                  class="font-weight-bold"
                                  style="padding: 0px !important"
                                  >Disability</span
                                >
                              </th>
                              <th>
                                <span
                                  class="font-weight-bold"
                                  style="padding: 0px !important"
                                  >Low Age</span
                                >
                              </th>
                              <th>
                                <span
                                  class="font-weight-bold"
                                  style="padding: 0px !important"
                                  >High Age</span
                                >
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr
                              v-for="item in Disabilities"
                              :key="item.DisabilityId"
                            >
                              <td style="padding-top: 2px !important">
                                {{ item.Description }}
                              </td>
                              <td style="padding-top: 2px !important">
                                {{ item.LowAge }}
                              </td>
                              <td style="padding-top: 2px !important">
                                {{ item.HighAge }}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>

              <table
                v-if="IsAllowPast22 != ''"
                class="pf-table mb-2"
                style="border-collapse: collapse"
              >
                <thead>
                  <tr>
                    <th>
                      <span class="font-weight-bold">Allow past age 22 - <cite>For educational programming only</cite> :</span>
                      {{ IsAllowPast22 }}
                    </th>
                  </tr>
                </thead>
              </table>
            </div>
          </div>

          <div class="card mb-3">
            <div class="card-header pf-nested-card-header font-weight-bold">
              Rate Information
            </div>

            <div class="card-body px-4 pt-3 pb-0">
              <div v-if="RnBRates.length > 0">
                <div class="flex-grow-1 pf-ghost-div px-4 pb-2 pt-2 m-3">
                  <span class="font-weight-bold">Room and Board</span>
                  <table
                    class="pf-table small"
                    style="empty-cells: hide !important"
                  >
                    <thead>
                      <tr>
                        <th>
                          <span
                            class="font-weight-bold"
                            style="padding: 0px !important"
                            >Begin Date</span
                          >
                        </th>
                        <th>
                          <span
                            class="font-weight-bold"
                            style="padding: 0px !important"
                            >End Date</span
                          >
                        </th>
                        <th>
                          <span
                            class="font-weight-bold"
                            style="padding: 0px !important"
                            >Days</span
                          >
                        </th>
                        <th>
                          <span
                            class="font-weight-bold"
                            style="padding: 0px !important"
                            >Per Diem</span
                          >
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="item in RnBRates" :key="item.RatesId">
                        <td style="padding-top: 2px !important">
                          {{ FormattedDate(item.BeginDate) }}
                        </td>
                        <td style="padding-top: 2px !important">
                          {{ FormattedDate(item.EndDate) }}
                        </td>
                        <td style="padding-top: 2px !important">
                          {{ item.Days }}
                        </td>
                        <td style="padding-top: 2px !important">
                          ${{ item.CostPerDay }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <div class="mt-2" v-if="TuitionRates.length > 0">
                <div class="flex-grow-1 pf-ghost-div px-4 pb-2 pt-2 m-3">
                  <span class="font-weight-bold">Tuition Rates</span>
                  <table
                    class="pf-table small"
                    style="empty-cells: hide !important"
                  >
                    <thead>
                      <tr>
                        <th>
                          <span
                            class="font-weight-bold"
                            style="padding: 0px !important"
                            >Begin Date</span
                          >
                        </th>
                        <th>
                          <span
                            class="font-weight-bold"
                            style="padding: 0px !important"
                            >End Date</span
                          >
                        </th>
                        <th>
                          <span
                            class="font-weight-bold"
                            style="padding: 0px !important"
                            >Days</span
                          >
                        </th>
                        <th>
                          <span
                            class="font-weight-bold"
                            style="padding: 0px !important"
                            >Per Diem</span
                          >
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="item in TuitionRates" :key="item.RatesId">
                        <td style="padding-top: 2px !important">
                          {{ FormattedDate(item.BeginDate) }}
                        </td>
                        <td style="padding-top: 2px !important">
                          {{ FormattedDate(item.EndDate) }}
                        </td>
                        <td style="padding-top: 2px !important">
                          {{ item.Days }}
                        </td>
                        <td style="padding-top: 2px !important">
                          ${{ item.CostPerDay }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>

          <div class="card mb-3">
            <div class="card-header pf-nested-card-header font-weight-bold">
              Calendar Information
            </div>
            <div class="card-body px-4 pt-1 pb-0">
              <div class="m-3" v-if="ApprovedCalendar != ''">
                Approved on :
                {{ ApprovedCalendar }}
              </div>              
            </div>

            <div class="card-body px-4 pt-0 pb-3">
              <div class="flex-grow-1 pf-ghost-div px-4 pb-2 pt-0 m-0 pb-3">
                <span class="font-weight-bold">Days Approved</span>
                <span class="font-weight-bold float-right" v-if="IsSchoolCalendarAvailable">
                  <a v-bind:href="ElectronicCalendarLink" target="_blank"><i class="fas fa-calendar-alt"></i> Electronic Calendar</a>
                </span>

                <div v-if="CalendarDates.length == 0" class="text-muted">
                  No data on file
                </div>

                <table
                  class="pf-table small"
                  style="empty-cells: hide !important"
                  v-else
                >
                  <thead>
                    <tr>
                      <th>
                        <span
                          class="font-weight-bold"
                          style="padding: 0px !important"
                          >Regular Begin Date</span
                        >
                      </th>
                      <th>
                        <span
                          class="font-weight-bold"
                          style="padding: 0px !important"
                          >Regular End Date</span
                        >
                      </th>
                      <th>
                        <span
                          class="font-weight-bold"
                          style="padding: 0px !important"
                          >Total Regular Days</span
                        >
                      </th>
                      <th>
                        <span
                          class="font-weight-bold"
                          style="padding: 0px !important"
                          >Summer Begin Date</span
                        >
                      </th>
                      <th>
                        <span
                          class="font-weight-bold"
                          style="padding: 0px !important"
                          >Summer End Date</span
                        >
                      </th>
                      <th>
                        <span
                          class="font-weight-bold"
                          style="padding: 0px !important"
                          >Total Summer Days</span
                        >
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td style="padding-top: 2px !important">
                        {{ RegularBeginDate_Reimbursement }}
                      </td>
                      <td style="padding-top: 2px !important">
                        {{ RegularEndDate_Reimbursement }}
                      </td>
                      <td style="padding-top: 2px !important">
                        {{ TotalApprovedRegularFullAttendance }}
                      </td>
                      <td style="padding-top: 2px !important">
                        {{ SummerBeginDate_Reimbursement }}
                      </td>
                      <td style="padding-top: 2px !important">
                        {{ SummerEndDate_Reimbursement }}
                      </td>
                      <td style="padding-top: 2px !important">
                        {{ ApprovedSummerRegularAttendance }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <div class="card mb-3">
            <div class="card-header pf-nested-card-header font-weight-bold">
              Associated Programs
            </div>

            <div class="card-body px-4 pt-1 pb-0">
              <div class="mt-2">
                <div class="flex-grow-1 pf-ghost-div px-4 pb-2 pt-2 m-3">
                  <span class="font-weight-bold">Programs</span>
                  <table
                    class="pf-table small"
                    style="empty-cells: hide !important"
                  >
                    <thead>
                      <tr>
                        <th>
                          <span
                            class="font-weight-bold"
                            style="padding: 0px !important"
                            >Program Id</span
                          >
                        </th>
                        <th>
                          <span
                            class="font-weight-bold"
                            style="padding: 0px !important"
                            >Name</span
                          >
                        </th>
                        <th>
                          <span
                            class="font-weight-bold"
                            style="padding: 0px !important"
                            >Facility Type
                          </span>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="item in AssociatedPrograms"
                        :key="item.RatesId"
                      >
                        <td style="padding-top: 2px !important">
                          {{ item.ProgramEntityId }}
                        </td>
                        <td style="padding-top: 2px !important">
                          {{ item.ProgramName }}
                        </td>
                        <td style="padding-top: 2px !important">
                          {{ item.ProgramType }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>

  <div class="card mb-3">  
   <div class="card-header pf-nested-card-header font-weight-bold">
     ISBE Review Information
   </div>
   <div class="card-body px-4 pt-3 pb-0">
     <table
       id="ProgInfoTable"
       class="pf-table"
       style="border-collapse: collapse"
     >
       <thead>
         <tr>
           <th>
             <span
               class="font-weight-bold"
               style="padding: 0px !important"
               >ISBE Reviewer : </span> <span class="font-weight-normal">{{ Program.AssignedConsultant }}</span>
           </th>             
         </tr>         
       </thead>      
     </table>
   </div> 
 </div>
        </div>
      </div>
    </main>
    <Footer />
  </div>
</template>

<script>
import Header from "../components/Header.vue";
import Footer from "../components/Footer.vue";
import moment from "moment";
import Constants from "../utilities/Constants.js";

export default {
  name: "Facility",
  components: {
    Header,
    Footer,
  },
  data() {
    return {
      FacilityInfo: [],
      Program: [],
      Disabilities: [],
      Rates: [],
      RnBRates: [],
      TuitionRates: [],
      AssociatedPrograms: [],
      CalendarDates: [],
      CalendarTotals: [],
      DisabilityTypeId: 0,
      HighAge: 0,
      LowAge: 0,
      TotalRegularFullAttendance: 0,
      TotalRegularHalfAttendance: 0,
      SummerRegularAttendance: 0,
      TotalApprovedRegularFullAttendance: 0,
      ApprovedSummerRegularAttendance: 0,
      SelectedYear: this.$route.params.year,
      SchoolYearOptions: [],
      IsNotApprovedForNewPlacement: false,
      IsSchoolCalendarAvailable: false,
      IsDaysApprovedAvailable: true,
    };
  },
  methods: {
    shareViaWebShare() {
      navigator.share({
        title: this.Program.ProgramName,
        text: this.Program.ProgramName,
        url: window.location,
      });
    },
    getFacilityInfo() {
      const FacilityDetailsURL = `${Constants.API_URL}/api/PFSearchApi/GetPFSearchProgramDetailsAsync?ProgramEntityId=${this.$route.params.id}&schoolYear=${this.$route.params.year}`;

      console.log(`Getting data from : ${FacilityDetailsURL}`);

      const cache = localStorage.getItem(FacilityDetailsURL);
      let o;
      if (cache) {
        o = JSON.parse(cache);
      }

      if (o && Date.now() <= o.expires) {
        this.SetupFacilityData(o.data);

        //console.log(o.data);
      } else {
        //console.log("getting data from web");

        fetch(FacilityDetailsURL)
          .then((response) => response.json())
          .then((data) => {
            console.log(data);

            this.SetupFacilityData(data);

            localStorage.setItem(
              FacilityDetailsURL,
              JSON.stringify({
                expires: Date.now() + 60 * 60 * 24 * 1000, // Cache for 24 hours
                data: data,
              })
            );
          });
      }
    },
    SetupFacilityData(data) {
      let years = data.SchoolYears;

      this.SchoolYearOptions = years.sort((a, b) => b - a).slice(0, 6);

      this.FacilityInfo = data;
      this.Program = data.Program;
      this.Disabilities = data.Disabilities;

      this.AssociatedPrograms = data.Programs;

      this.Rates = data.Rates;
      this.RnBRates = this.Rates.filter(function (rate) {
        return rate.RateTypeId == 1;
      });
      this.TuitionRates = this.Rates.filter(function (rate) {
        return rate.RateTypeId == 2;
      });
      this.CalendarDates =
        data.CalendarDates == null ? [] : data.CalendarDates[0];

      this.CalendarDates = this.CalendarDates == null ? [] : this.CalendarDates;

      console.log(this.IsSchoolCalendarAvailable);
      console.log(this.CalendarDates);

      this.IsSchoolCalendarAvailable = this.CalendarDates.length == 0 ? false : true;

      console.log(this.IsSchoolCalendarAvailable);

      this.CalendarTotals =
        data.CalendarTotals == null ? [] : data.CalendarTotals;
      this.TotalRegularFullAttendance =
        this.CalendarTotals.length == 0
          ? ""
          : this.CalendarTotals.filter(function (calendarTotal) {
              return calendarTotal.Attendance == "TotalRegularFullAttendance";
            }).slice(0, 1)[0].DayCount;

      this.TotalRegularHalfAttendance =
        this.CalendarTotals.length == 0
          ? ""
          : this.CalendarTotals.filter(function (calendarTotal) {
              return calendarTotal.Attendance == "TotalRegularHalfAttendance";
            }).slice(0, 1)[0].DayCount;

      this.SummerRegularAttendance =
        this.CalendarTotals.length == 0
          ? ""
          : this.CalendarTotals.filter(function (calendarTotal) {
              return calendarTotal.Attendance == "SummerRegularAttendance";
            }).slice(0, 1)[0].DayCount;

      this.TotalApprovedRegularFullAttendance =
        this.CalendarTotals.length == 0
          ? ""
          : this.CalendarTotals.filter(function (calendarTotal) {
              return (
                calendarTotal.Attendance == "TotalApprovedRegularFullAttendance"
              );
            }).slice(0, 1)[0].DayCount;

      this.ApprovedSummerRegularAttendance =
        this.CalendarTotals.length == 0
          ? ""
          : this.CalendarTotals.filter(function (calendarTotal) {
              return (
                calendarTotal.Attendance == "ApprovedSummerRegularAttendance"
              );
            }).slice(0, 1)[0].DayCount;

      this.DisabilityTypeId = data.DisabilityTypeId;
      this.HighAge = data.HighAge;
      this.LowAge = data.LowAge;
      this.IsNotApprovedForNewPlacement = !this.Program.AllowNewPlacements;

      document.getElementById("pageProgress").classList.add("hidden");
    },
    UpdateSchoolYear() {
      // console.log(this.SelectedYear);
      // console.log(this.$route.params.id);
      let lnk =
        "/pfsearch/facility/" + this.SelectedYear + "/" + this.$route.params.id;
      //console.log(lnk);

      window.open(lnk, "_self");

      //document.querySelector(".modal").style.show = "false";
    },
    FormattedDate: function (date) {
      return date == null ? "" : moment(date).format("M/DD/YYYY");
    },

    FormatPhoneNumber(number) {
      let cleaned = ("" + number).replace(/\D/g, "");

      //Check if the input is of correct length
      let match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);

      if (match) {
        return "(" + match[1] + ") " + match[2] + "-" + match[3];
      }

      return number;
    },
  },
  computed: {
    ApprovedCalendar() {
      //console.log(this.Program.CalendarApprovedDate);

      if (this.Program.CalendarApprovedDate != null) {
        return moment(this.Program.CalendarApprovedDate).format("M/DD/YYYY");
      }
      return "";
    },

    IsAllowPast22() {
      //  console.log(this.Program.AssignedConsultant);
      if (this.Program.AllowPastAge22 != null) {
        return this.Program.AllowPastAge22 ? "Yes" : "No";
      }
      return "";
    },

    RegularBeginDate_SchoolCalendar() {
      if (this.CalendarDates.RegularBeginDate != null) {
        return moment(this.CalendarDates.RegularBeginDate).format("M/DD/YYYY");
      }
      return "";
    },
    RegularEndDate_SchoolCalendar() {
      if (this.CalendarDates.RegularEndDate != null) {
        return moment(this.CalendarDates.RegularEndDate).format("M/DD/YYYY");
      }
      return "";
    },
    SummerBeginDate_SchoolCalendar() {
      if (this.CalendarDates.SummerBeginDate != null) {
        return moment(this.CalendarDates.SummerBeginDate).format("M/DD/YYYY");
      }
      return "";
    },
    SummerEndDate_SchoolCalendar() {
      if (this.CalendarDates.SummerEndDate != null) {
        return moment(this.CalendarDates.SummerEndDate).format("M/DD/YYYY");
      }
      return "";
    },

    RegularBeginDate_Reimbursement() {
      if (this.CalendarDates.ApprovedRegularBeginDate != null) {
        return moment(this.CalendarDates.ApprovedRegularBeginDate).format(
          "M/DD/YYYY"
        );
      }
      return "";
    },
    RegularEndDate_Reimbursement() {
      if (this.CalendarDates.ApprovedRegularEndDate != null) {
        return moment(this.CalendarDates.ApprovedRegularEndDate).format(
          "M/DD/YYYY"
        );
      }
      return "";
    },
    SummerBeginDate_Reimbursement() {
      if (this.CalendarDates.ApprovedSummerBeginDate != null) {
        return moment(this.CalendarDates.ApprovedSummerBeginDate).format(
          "M/DD/YYYY"
        );
      }
      return "";
    },
    SummerEndDate_Reimbursement() {
      if (this.CalendarDates.ApprovedSummerEndDate != null) {
        return moment(this.CalendarDates.ApprovedSummerEndDate).format(
          "M/DD/YYYY"
        );
      }
      return "";
    },

    ElectronicCalendarLink() {
      // return (
      //   "https://apps.isbe.net/FacilityInquiry/UtilityPage/PFCalendar.aspx?SchoolYear=" +
      //   this.$route.params.year +
      //   "&ProgramId=" +
      //   this.$route.params.id
      // );

      return (
        "/pfsearch/calendar/" +
        this.$route.params.year +
        "/" +
        this.$route.params.id
      );
    },

    webShareApiSupported() {
      return navigator.share;
    },
    //$route.params.year
    YearDisplay() {
      let schoolYear = parseInt(this.$route.params.year);
      return schoolYear - 1 + "-" + schoolYear;
    },
    GoogleAddress() {
      return "https://www.google.com/maps/place/" + this.Program.ProgramAddress;
    },
    ProgramURL() {
      let url = this.Program.ProgramWebsiteUrl;
      //console.log(url);
      return url; //.replace("http://", "").replace("https://", "");
    },
    ProgramPhone() {
      return "tel:" + this.Program.ProgramPhone;
    },
    ProgramFax() {
      return "tel:" + this.Program.ProgramFax;
    },
    ProgramAdminEmail() {
      return "mailto:" + this.Program.ProgramAdminEmail;
    },
    LimitedApproval() {
      if (!this.Program.AllowNewPlacements) {
        return "New Placements Not Allowed";
      }
      return "Not Limited";
    },
    IsProgramClosed: function () {
      return this.Program.ClosedDate != null;
    },
    // IsNotApprovedForNewPlacement: function () {
    //   return this.Program.AllowNewPlacements;
    // },
  },
  mounted() {
    document.getElementById("pageProgress").classList.remove("hidden");
    this.getFacilityInfo();
  },
};
</script>

